export const ChordLabellingSystemOptions = [
    { label: "Fixed-Do Solfège System (固定调)" },
    { label: "Movable-Do Solfège System (首调)" },
]

export const ChordLabellingSystemInstruction = `- 为了确保我们能够准确理解您对和弦的标注，您应当在标注和弦之前选择您采用的是固定调还是首调！
- 在首调体系中，由于表述习惯的差异，我们很可能会产生一些意思偏差。因此如果您采用首调，我们在此处为您进行一些注解：
- 假设一首C大调的歌的一段和弦为C-Am-F-G，则您毫无疑问会选择1级-6级-5级-4级
- 假设一首歌不断重复的和弦为Am-Em-Am-Em，如果您将这首歌已经标注为A小调，则您应该选择1级-5级-1级-5级
- 还是这首和弦为Am-Em-Am-Em的歌，如果您将这首歌标注为了C调（这种简易方法在流行音乐中并不少见），则您应该选择6级-3级-6级-3级
反之，您不应该做的是：将这首和弦为Am-Em-Am-Em的歌，在选择标注为A小调的情况下，却将和弦标注为6级-3级-6级-3级。这是绝对不对的！
- To ensure your chord annotations are correctly assigned, please choose whether you are using Movable-Do Solfge System or Fixed-Do Solfge System before labeling any chords.
- *Important notes for Movable Do users:
- Example 1: In a song in C major, a chord progression of C–Am–F–G should be labeled I–vi–IV–V.
- Example 2: In a song with repeated chords Am–Em–Am–Em, if you've already marked the key as A minor, label the chords as i–v–i–v.
- However, if you've marked the key as C major (common in simplified pop music analysis), then the same progression would be vi–iii–vi–iii.
Do not mix systems. For example, labeling Am–Em–Am–Em as vi–iii–vi–iii while indicating the key is A minor is incorrect.`

export const FixedDoSystemChordDegreeAttributes = [
    {
        name: "sharp_flat",
        questionText: "Sharp/Flat (升降号)",
        type: "multiple-choice",
        mandatory: false,
        items: [
            { label: "#" },
            { label: "♭" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    },
    {
        name: "note",
        questionText: "Note (音符)",
        type: "multiple-choice",
        mandatory: true,
        items: [
            { label: "C" },
            { label: "D" },
            { label: "E" },
            { label: "F" },
            { label: "G" },
            { label: "A" },
            { label: "B" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    }
]

export const MovableDoSystemChordDegreeAttributes = [
    {
        name: "sharp_flat",
        questionText: "Sharp/Flat (升降号)",
        type: "multiple-choice",
        mandatory: false,
        items: [
            { label: "#" },
            { label: "♭" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    },
    {
        name: "note",
        questionText: "Note (音符)",
        type: "multiple-choice",
        mandatory: true,
        items: [
            { label: "1级" },
            { label: "2级" },
            { label: "3级" },
            { label: "4级" },
            { label: "5级" },
            { label: "6级" },
            { label: "7级" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    }
]

export const ChordTypeAttributes = [
    {
        name: "chord_type",
        type: "multiple-choice",
        questionText: "Chord Type (和弦色彩)",
        mandatory: true,
        items: [
            {
                label: "Triads（三和弦）",
                children: [
                    { label: "maj" },
                    { label: "m" },
                    { label: "dim" },
                    { label: "aug" },
                    { label: "5" },
                    { label: "sus2" },
                    { label: "sus4" }
                ]
            },
            {
                label: "Added-note (no 7th)（加音和弦〔无七度〕）",
                children: [
                    { label: "6" },
                    { label: "6/9" },
                    { label: "add9" },
                    { label: "add11" },
                    { label: "add13" },
                    { label: "m6" },
                    { label: "m6/9" },
                    { label: "madd9" },
                    { label: "madd11" },
                    { label: "maddb13" },
                    { label: "sus4add9" }
                ]
            },
            {
                label: "Sevenths (foundations)（七和弦〔基型〕）",
                children: [
                    { label: "maj7" },
                    { label: "m7" },
                    { label: "7" },
                    { label: "m7b5" },
                    { label: "dim7" },
                    { label: "mMaj7" }
                ]
            },
            {
                label: "Extended — Major family（扩展和弦——大三和弦族）",
                children: [
                    { label: "maj7#11" },
                    { label: "maj9" },
                    { label: "maj9#11" },
                    { label: "maj13" },
                    { label: "maj13#11" },
                    { label: "maj7#5" }
                ]
            },
            {
                label: "Extended — Minor family（扩展和弦——小三和弦族）",
                children: [
                    { label: "m9" },
                    { label: "m11" },
                    { label: "m13" },
                    { label: "mMaj9" },
                    { label: "m9b5" },
                    { label: "m7#5" },
                    { label: "m7b13" },
                    { label: "m7add11" }
                ]
            },
            {
                label: "Dominant — unaltered / suspended / adds（属和弦——无变音／挂留／加音）",
                children: [
                    { label: "9" },
                    { label: "11" },
                    { label: "13" },
                    { label: "7sus4" },
                    { label: "9sus4" },
                    { label: "13sus4" },
                    { label: "7add11" },
                    { label: "7add13" }
                ]
            },
            {
                label: "Dominant — altered — 7 family（属和弦——变音——7系列）",
                children: [
                    { label: "7b9" },
                    { label: "7#9" },
                    { label: "7#11" },
                    { label: "7b13" },
                    { label: "7#5" },
                    { label: "7b9#9" },
                    { label: "7b9#11" },
                    { label: "7b9b13" },
                    { label: "7b9#5" },
                    { label: "7#9#11" },
                    { label: "7#9b13" },
                    { label: "7#9#5" },
                    { label: "7#11b13" },
                    { label: "7#11#5" },
                    { label: "7b9#9#11" },
                    { label: "7b9#9b13" },
                    { label: "7b9#9#5" },
                    { label: "7b9#11b13" },
                    { label: "7b9#11#5" },
                    { label: "7#9#11b13" },
                    { label: "7#9#11#5" }
                ]
            },
            {
                label: "Dominant — altered — 9 family（属和弦——变音——9系列）",
                children: [
                    { label: "9#11" },
                    { label: "9b13" },
                    { label: "9#5" },
                    { label: "9#11b13" },
                    { label: "9#11#5" },
                    { label: "7#5(9)" }
                ]
            },
            {
                label: "Dominant — altered — 11 family（属和弦——变音——11系列）",
                children: [
                    { label: "11b9" },
                    { label: "11#9" },
                    { label: "11#5" },
                    { label: "11b9#9" },
                    { label: "11b9#5" },
                    { label: "11#9#5" },
                    { label: "11b9#9#5" }
                ]
            },
            {
                label: "Dominant — altered — 13 family（属和弦——变音——13系列）",
                children: [
                    { label: "13b9" },
                    { label: "13#9" },
                    { label: "13#11" },
                    { label: "13b13" },
                    { label: "13#5" },
                    { label: "13b9#9" },
                    { label: "13b9#11" },
                    { label: "13b9b13" },
                    { label: "13b9#5" },
                    { label: "13#9#11" },
                    { label: "13#9b13" },
                    { label: "13#9#5" },
                    { label: "13#11b13" },
                    { label: "13#11#5" },
                    { label: "13b9#9#11" },
                    { label: "13b9#9b13" },
                    { label: "13b9#9#5" },
                    { label: "13b9#11b13" },
                    { label: "13b9#11#5" },
                    { label: "13#9#11b13" },
                    { label: "13#9#11#5" }
                ]
            },
            {
                label: "Dominant — altered — 7sus4 family（属和弦——变音——7sus4系列）",
                children: [
                    { label: "7sus4b9" },
                    { label: "7sus4#9" },
                    { label: "7sus4b13" },
                    { label: "7sus4b9#9" },
                    { label: "7sus4b9b13" },
                    { label: "7sus4#9b13" },
                    { label: "7sus4b9#9b13" }
                ]
            }
        ],
        allowAnyLevelSelection: false,
        singleSelect: true,
    }
]


export const FixedDoBaseAttributes = [
    {
        name: "bass_sharp_flat",
        questionText: "Sharp/Flat (升降号)",
        type: "multiple-choice",
        mandatory: false,
        items: [
            { label: "#" },
            { label: "♭" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    },
    {
        name: "bass_note",
        questionText: "Note (音符)",
        type: "multiple-choice",
        mandatory: true,
        items: [
            { label: "C" },
            { label: "D" },
            { label: "E" },
            { label: "F" },
            { label: "G" },
            { label: "A" },
            { label: "B" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    }
]

export const MovableDoBaseAttributes = [
    {
        name: "bass_sharp_flat",
        questionText: "Sharp/Flat (升降号)",
        type: "multiple-choice",
        mandatory: false,
        items: [
            { label: "#" },
            { label: "♭" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    },
    {
        name: "bass_note",
        questionText: "Note (音符)",
        type: "multiple-choice",
        mandatory: true,
        items: [
            { label: "1" },
            { label: "2" },
            { label: "3" },
            { label: "4" },
            { label: "5" },
            { label: "6" },
            { label: "7" },
        ],
        allowAnyLevelSelection: false,
        singleSelect: true
    }
]

export const FixedDoChordAttributes = {
    'Chord Degree (和弦级数)': FixedDoSystemChordDegreeAttributes,
    'Chord Type (和弦色彩)': ChordTypeAttributes,
    'Bass (低音)': FixedDoBaseAttributes,
}

export const MovableDoChordAttributes = {
    'Chord Degree (和弦级数)': MovableDoSystemChordDegreeAttributes,
    'Chord Type (和弦色彩)': ChordTypeAttributes,
    'Bass (低音)': MovableDoBaseAttributes,
}
